<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="130px" v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="transportCompany" label="运输公司">
              <el-input v-model="formData.transportCompany" placeholder="请输入运输公司" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="transportDate" label="运输日期">
              <el-date-picker
                v-model="formData.transportDate"
                placeholder="请选择运输日期"
                type="date"
                clearable
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="transportType" label="送货/进货">
              <el-select v-model="formData.transportType" clearable filterable placeholder="请选择送货/进货">
                <el-option v-for="item in transportTypeArr" :key="item" :label="item" :value="item" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleNumber" label="车船号">
              <el-select
                v-model="formData.currentVehicle"
                clearable
                filterable
                placeholder="请选择车船号"
                @change="carChange"
              >
                <el-option
                  v-for="item in carList"
                  :key="item.vehicleId"
                  :value="`${item.vehicleKey}(${item.driverName})`"
                  :label="`${item.vehicleKey}(${item.driverName})`"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="driverName" label="司机姓名">
              <el-input v-model="formData.driverName" placeholder="自动带出" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driverId" label="身份证">
              <el-input v-model="formData.driverId" placeholder="自动带出" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="driverPhone" label="联系方式">
              <el-input v-model="formData.driverPhone" placeholder="自动带出" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="goodsId" label="货品">
              <el-select v-model="formData.goodsId" clearable filterable placeholder="请选择货品">
                <el-option v-for="(item, index) of specList" :value="item.specId" :label="item.specName" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="goodsNum" label="数量">
              <el-input v-model="formData.goodsNum" placeholder="请输入数量" @input="calcTotalPrice" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="freightType" label="类型">
              <el-select v-model="formData.freightType" clearable filterable placeholder="请选择类型" @change="calcTotalPrice">
                <el-option v-for="item in freightTypeArr" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="unitPrice" label="费用">
              <el-input v-model="formData.unitPrice" placeholder="请输入费用" @input="calcTotalPrice" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="totalPrice" label="总价">
              <el-input v-model="formData.totalPrice" placeholder="自动计算" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
export default {
  name: 'freightRecordEdit',
  data() {
    // 两位小数正则
    const decimal2Reg = /^\d+(\.\d{1,2})?$/
    return {
      formData: {
        freightId: '',
        transportCompany: '',
        transportDate: '',
        transportType: '',
        vehicleNumber: '',
        driverName: '',
        driverId: '',
        driverPhone: '',
        goodsId: null,
        goodsNum: '',
        freightType: '',
        unitPrice: '',
        totalPrice: ''
      },
      transportTypeArr: ['送货', '进货'],
      freightTypeArr: [
        { label: '一口价', value: '1' },
        { label: '单价', value: '2' }
      ],
      carList: [],
      specList: [],
      rules: {
        transportCompany: [{ required: true, message: '请输入运输公司', trigger: ['blur', 'change'] }],
        transportDate: [{ required: true, message: '请选择运输日期', trigger: ['blur', 'change'] }],
        transportType: [{ required: true, message: '请选择送货/进货', trigger: ['blur', 'change'] }],
        vehicleNumber: [{ required: true, message: '请选择车船号', trigger: ['blur', 'change'] }],
        driverName: [{ required: true, message: '司机姓名不能为空', trigger: ['blur', 'change'] }],
        driverId: [{ required: true, message: '身份证不能为空', trigger: ['blur', 'change'] }],
        driverPhone: [{ required: true, message: '联系方式不能为空', trigger: ['blur', 'change'] }],
        goodsId: [{ required: true, message: '请选择货品', trigger: ['blur', 'change'] }],
        goodsNum: [{ required: true, message: '请输入数量', trigger: ['blur', 'change'] }],
        freightType: [{ required: true, message: '请选择类型', trigger: ['blur', 'change'] }],
        unitPrice: [
          { required: true, message: '请输入费用', trigger: ['blur', 'change'] },
          {
            validator: (rule, value, callback) => {
              if (value && !decimal2Reg.test(value)) {
                return callback(new Error('费用只能输入数字，最多两位小数'))
              }
              callback()
            },
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: false
    }
  },
  computed: {
    freightId() {
      return this.$route.query.freightId
    }
  },
  created() {
    this.loadCarList()
    this.loadSpecList()
    if (this.freightId) {
      this.loadData()
    }
  },
  methods: {
    // 加载车辆
    loadCarList() {
      this.$axios.get(this.$apis.carManage.selectWlVehicleInfoByPage).then(res => {
        this.carList = res.list || []
      })
    },
    // 加载货品字典（原品种规格接口）
    loadSpecList() {
      this.$axios.get(this.$apis.grainSpecifications.selectYxOilSpecByList).then(res => {
        this.specList = res.list || []
      })
    },
    carChange(val) {
      if (!val) {
        this.formData.vehicleNumber = ''
        this.formData.driverName = ''
        this.formData.driverId = ''
        this.formData.driverPhone = ''
        return
      }
      const arr = val.match(/(.+)\((.+)\)/).slice(1)
      const carInfo = this.carList.find(item => {
        return arr.length === 2 && item.vehicleKey === arr[0] && item.driverName === arr[1]
      })
      if (carInfo) {
        this.formData.vehicleNumber = carInfo.vehicleKey
        this.formData.driverName = carInfo.driverName
        this.formData.driverId = carInfo.driverKey
        this.formData.driverPhone = carInfo.driverMobile
      }
    },
    calcTotalPrice() {
      const { freightType, unitPrice, goodsNum } = this.formData
      if (!freightType || !unitPrice) {
        this.formData.totalPrice = ''
        return
      }
      const up = Number(unitPrice) || 0
      const gn = Number(goodsNum) || 0
      if (freightType === '1') {
        this.formData.totalPrice = up.toFixed(2)
      } else if (freightType === '2') {
        this.formData.totalPrice = (gn * up).toFixed(2)
      }
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.wlFreight.selectWlFreightByFreightId, {
        params: { freightId: this.freightId }
      }).then(res => {
        this.formData = { ...this.formData, ...res, currentVehicle: res.vehicleNumber + '(' + res.driverName + ')' }
        this.$nextTick(() => {
          if (this.formData.currentVehicle) {
            this.carChange(this.formData.currentVehicle)
          }
          this.calcTotalPrice()
        })
      }).finally(() => {
        this.loading = false
      })
    },
    submit() {
      this.$refs.form.validate().then(() => {
        this.loading = true
        let apiUrl
        if (this.freightId) {
          apiUrl = this.$apis.wlFreight.updateWlFreight
        } else {
          apiUrl = this.$apis.wlFreight.insertWlFreight
        }
        const data = { ...this.formData }
        delete data.currentVehicle
        this.$axios.post(apiUrl, data).then(() => {
          this.$router.back()
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {
  .el-input,
  .el-select,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
